console.log('thumbnail-variant-select loaded');
(function () {
  const fileName = (url) => (url || '').split('?')[0].split('/').pop();

  function merge(map, key, opts) {
    // Keep only the options that all variants sharing this image agree on
    map[key] = map[key] ? map[key].map((v, i) => (v === opts[i] ? v : null)) : opts.slice();
  }

  function applyOptions(root, options) {
  const groups = root.querySelectorAll('variant-selects .product-form__input');
  const norm = (s) => String(s).normalize('NFC').replace(/\s+/g, ' ').trim();
  const pending = [];
  let changed = null;

  options.forEach((value, i) => {
    if (value === null || !groups[i]) return;

    const select = groups[i].querySelector('select');
    if (select) {
      const opts = Array.from(select.options);
      let idx = opts.findIndex((o) => o.value === value);
      if (idx === -1) idx = opts.findIndex((o) => norm(o.value) === norm(value));
      if (idx === -1 || idx === select.selectedIndex) return;
      pending.push({ select, opts, idx });
      return;
    }

    const radio = Array.from(groups[i].querySelectorAll('input[type="radio"]')).find(
      (r) => norm(r.value) === norm(value)
    );
    if (radio && !radio.checked) {
      radio.checked = true;
      changed = radio;
    }
  });

  // If a radio is the event target, every changed select must be synced by hand.
  // Otherwise the last changed select is the event target and Dawn syncs that one.
  const target = changed ? null : pending.pop();

  pending.forEach(({ select, opts, idx }) => {
    opts.forEach((o) => o.removeAttribute('selected'));
    opts[idx].setAttribute('selected', 'selected');
    select.selectedIndex = idx;
  });

  if (target) {
    const { select, opts, idx } = target;
    const old = select.selectedIndex;
    // Dawn removes the attribute from the old option; it must never be the new one
    const holder = old >= 0 && old !== idx ? old : opts.findIndex((o, i) => i !== idx);
    opts.forEach((o, i) => (i === holder ? o.setAttribute('selected', 'selected') : o.removeAttribute('selected')));
    select.selectedIndex = idx;
    changed = select;
  }

  if (changed && changed.isConnected && (changed.tagName !== 'SELECT' || changed.selectedOptions.length > 0)) {
    changed.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

async function init(root) {
  if (root.dataset.thumbVariantBound) return;
  root.dataset.thumbVariantBound = 'true';

  let product;
  try {
    const jsonEl = document.getElementById('ProductJson-' + root.dataset.section);
    product = jsonEl
      ? JSON.parse(jsonEl.textContent)
      : await (await fetch(root.dataset.url + '.js')).json();
  } catch (e) {
    console.warn('[tvs] could not load product data', e);
    return;
  }
  console.log('[tvs] product loaded, variants:', product.variants.length);

  const imageMap = {};
  const mediaMap = {};
  product.variants.forEach((variant) => {
    if (variant.featured_image) merge(imageMap, fileName(variant.featured_image.src), variant.options);
    if (variant.featured_media) merge(mediaMap, String(variant.featured_media.id), variant.options);
  });
  console.log('[tvs] maps', { imageMap, mediaMap });

  root.addEventListener('click', (e) => {
    const thumb = e.target.closest('.thumbnail');
    if (!thumb) return;
    const img = thumb.querySelector('img');
    const holder = thumb.closest('[data-target]');
    const mediaId = holder ? holder.dataset.target.split('-').pop() : null;
    const options = (mediaId && mediaMap[mediaId]) || (img && imageMap[fileName(img.src)]);
    console.log('[tvs] thumbnail click', mediaId, options);
    if (options) applyOptions(root, options);
  });
}
function boot() {
  const roots = document.querySelectorAll('product-info[id^="MainProduct-"]');
  console.log('[tvs] boot, product-info found:', roots.length);
  roots.forEach(init);
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();